var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /** @format */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { List } from 'immutable';
import "./scss/stackTrace.scss";
import { Icon } from "../../UI";

const conformValidations = (expand, validations) => {
  if (!expand || !validations) {
    return null;
  }

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    validations.reduce(
      (memo, v, i) =>
      memo.concat( /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _jsx("div", {}, i,
        v.get('message'), ": ", v.get('instancePath')
        )
      ),
      []
    )
    ));

};

class StackTrace extends Component {
  constructor(props) {
    super(props);
    this.state = { expand: false };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const { expand } = this.state;
    this.setState({ expand: !expand });
  }

  render() {
    const { message, validations } = this.props;
    const { expand } = this.state;
    const formatedMessage = expand ? message : `${message.substr(0, 50)}...`;
    return /*#__PURE__*/(
      _jsx("div", { className: "stack-trace", onClick: this.toggle }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "sort" }), "\xA0", /*#__PURE__*/

      _jsx("span", {}, void 0, formatedMessage),
      conformValidations(expand, validations)
      ));

  }
}

StackTrace.defaultProps = {
  message: '',
  validations: null
};






export default StackTrace;